import { type SystemType } from '../../@types/SystemType.js';
import Board from './Board.js';

abstract class BoardPoolgames extends Board<SystemType> {
  get systemType(): SystemType {
    // if (this.systemNumber) {
    //   const system = systems.getSystemFromNumber(this.systemNumber);

    //   switch (system.systemType) {
    //     case 'R':
    //       return SystemType.RSYS;
    //     case 'U':
    //       return SystemType.USYS;
    //     default:
    //       throw new Error(`Unsupported system type: ${system?.systemType}`);
    //   }
    // }

    for (const outcomeGroups of this.outcomes) {
      const systemSize = outcomeGroups.reduce((sum, outcomes) => sum * outcomes.length, 1);
      if (systemSize !== 1) {
        return 'MSYS';
      }
    }

    // if system is of type MSYS but there is only combinations that sums to one row (SROW)
    // the bet should be placed as system type SROW
    return 'SROW';
  }

  override toString(isCompact?: boolean): string {
    return super.toString(isCompact);
  }
}

export default BoardPoolgames;
